import PublicLayout from '../components/PublicLayout.jsx';
import ContactSection from '../components/ContactSection.jsx';

export default function KontakPage() {
  return (
    <PublicLayout>
      <div className="h-24" />
      <ContactSection />
    </PublicLayout>
  );
}
